import $FormJS from "../../utils/form";
import formcontent from "../../form_content/index.vue";
import tinymce from "../../tinymce/tinymce.vue";
import selectinfo from "../../selectSingle/selectSingle.vue";
export default {
  components: {
    formcontent,
    tinymce,
    selectinfo,
  },
  name: "YnFormSend",
  data() {
    return {
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static",
      },
      showPopu: false,
      searchItem: {},
      formSet: {},
      formInfo: {},
      list: [],
      tableColumns: [],

      showModal: false,
      showSend: false,
      //表单处理：
      user: {
        type: "",
      },
      config: JSON.parse(localStorage.getItem("config")),

      weekList: [],

      showTable: true,
      pageOpt: [10, 20, 50, 100],
      total: 0,
      currentPageSize: 10,
      currentPage: 1,
      dateDay: [
        {
          title: "上午",
          key: "am",
        },
        {
          title: "下午",
          key: "pm",
        },
      ],
      showContent: false,
      lookForm: {},
      flows: [],
      targetList: [],

      formData: {},
      typeList: [],
      wzList: [],
      setItem: {},
    };
  },
  computed: {
    currentPaths() {
      return this.$store.state.app.currentPaths[
        this.$store.state.app.currentPaths.length - 1
      ];
    },
    userInfo() {
      return this.$store.state.user;
    },
  },
  props: {
    formId: {
      type: String,
      default() {
        return "";
      },
    },
    baseURL: {
      type: String,
      default: "",
    },
  },
  watch: {
    formId(val) {
      console.log(`watchForm:${this.formId},val:${val}`);
      if (this.formId && this.formId.length > 0) {
        this.getFormInfo();
      }
    },
  },
  methods: {
    // 物资信息
    initDict() {
      this.$axios({
        baseURL: JSON.parse(localStorage.getItem("config")).tyrz,
        url: "dict/list/types",
        method: "POST",
        data: ["物资类型"],
      }).then((res) => {
        var data = res.data;
        this.typeList = data["物资类型"];
      });
    },
    savePopu() {
      var array = this.setItem.set.value;
      if (!array || array.length == 0) {
        array = [];
      }
      var a = JSON.parse(JSON.stringify(array));
      a.push(this.formData);
      this.setItem.set.value = a;
      this.showPopu = false;
      this.initFlow();
    },
    removeWZ(i, set) {
      var array = set.value;

      var a = JSON.parse(JSON.stringify(array));

      a.splice(i, 1);

      if (a.length == 0) {
        set.value = "";
        return;
      }
      set.value = a;

      this.initFlow();
    },
    addWz(item) {
      this.setItem = item;
      this.formData = {
        count: 1,
      };

      this.initDict();
      this.showPopu = true;
    },
    typeChange(type) {
      var data = Object.assign({}, this.formData);
      data.wzId = "";
      this.formData = Object.assign({}, data);
      var url = `goods/info/${type}/list`;
      if (this.setItem.set.control == "wz_sq") {
        url = "goods/list/gg/" + type;
      }
      this.$axios({
        baseURL: this.config.logistics,
        url: url,
        method: "POST",
        data: {
          isOpen: 1,
          searchKey: "",
        },
      }).then((res) => {
        if (res.code == 200) {
          this.wzList = res.data;
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    wzChange(index) {
      // var list = this.wzList.filter((a) => {
      //   return a.wzId == wzId;
      // });
      var model = this.wzList[index];
      var data = Object.assign({}, this.formData);
      // if (list && list.length > 0) {
        // var model = list[0];
        data.title = model.title;
        data.wzId = model.wzId;
        data.ggbz = model.ggbz;
        data.price = model.price;

        data.title = model.title;
        if (model.ggbz && model.ggbz.length > 0) {
          data.title += `（${model.ggbz}）`;
        }
      // }
      this.formData = Object.assign({}, data);
    },

    //组件整理
    selectSignalInfo(model, data) {
      // var self = this;

      if (data) {
        console.log(1);
        model.value = data;
      } else {
        console.log(2);
        model.value = {};
      }

      console.log(
        `model:${JSON.stringify(model)},
        data:${JSON.stringify(data)}`
      );
      // this.targetList = [];
      // model.value = data;
    },

    look(index) {
      this.lookForm = JSON.parse(JSON.stringify(this.list[index]));
      console.log(`lookForm:${JSON.stringify(this.lookForm)}`);
      this.showContent = true;
    },
    setShowStyle(type) {
      if (type == 1) {
        this.showTable = true;
        this.currentPageSize = 10;
        this.pageOpt = [10, 20, 50, 100];
      } else {
        this.showTable = false;
        this.currentPageSize = 8;
        this.pageOpt = [8, 16, 32, 80];
      }
      this.getData();
    },
    formTitle(item) {
      return $FormJS.formTitle(item, this.formSet);
    },
    formContent(item) {
      return $FormJS.formContent(item, this.formSet);
    },
    formStatus(status, action) {
      return $FormJS.formStatus(status, action);
    },
    formStatusType(status, action) {
      return $FormJS.formStatusType(status, action);
    },
    dateFormatter(time) {
      return $FormJS.dateFormatter(time);
    },
    pageSizeChange(pageSize) {
      this.currentPageSize = pageSize;
      this.getData();
    },
    pageChange(page) {
      this.currentPage = page;
      this.getData();
    },
    // 数据处理
    // 获取当前用户信息
    getUsers() {
      this.$axios({
        baseURL: this.config.tyrz,
        url: `users/${this.userInfo.uid}`,
        method: "GET",
      }).then((res) => {
        if (res.code == 200) {
          var info = res.data;
          this.user = info;
        }
      });
    },
    getGender(gender) {
      if (gender == 1) return "男";
      if (gender == 2) return "女";
      return "保密";
    },
    // 时间选择问题
    //时间区间处理
    setStart(model, start) {
      model.start = start;
      if (model.end && model.end.length > 0) {
        model.value = this.getTimeDiff(start, model.end, model.unit, model);
      }
      this.initFlow();
      console.log("model:" + JSON.stringify(model));
    },
    startChange(e, set) {
      // var day = this.dateDay[e];
      set.startIndex = e;
      if (set.start && set.start.length > 0 && set.end && set.end.length > 0) {
        set.value = this.getTimeDiff(set.start, set.end, set.unit, set) + "";
      }
      this.initFlow();
    },

    setEnd(model, end) {
      model.end = end;
      console.log("end:" + end);
      if (model.start && model.start.length > 0) {
        model.value =
          this.getTimeDiff(model.start, end, model.unit, model) + "";
      }
      this.initFlow();
      console.log("model:" + JSON.stringify(model));
    },
    endChange(e, set) {
      // var day = this.dateDay[e.target.value];
      set.endIndex = e;
      if (set.start && set.start.length > 0 && set.end && set.end.length > 0) {
        set.value = this.getTimeDiff(set.start, set.end, set.unit, set) + "";
      }
      this.initFlow();
    },
    radioChange(model, event) {
      this.initFlow();
      // console.log(`model:${JSON.stringify(model)},event:${JSON.stringify(event.detail)}`)
    },
    // checkChange(model, event) {
    // 	console.log(`checkbox:${JSON.stringify(event.detail.value)}`)
    // 	model.value = event.detail.value;

    // 	// this.initFlow();
    // 	// console.log(`model:${JSON.stringify(model)},event:${JSON.stringify(event.detail)}`)
    // },
    timeChange(model, time) {
      model.value = time;
    },
    getTimeDiff(start, end, type, model) {
      console.log("计算时长");
      if (model.isTil && type == "date") {
        start = start.replace(/-/g, "/");
        end = end.replace(/-/g, "/");
        if (model.startIndex == 0) {
          start += " 00:00:00";
        } else {
          start += " 12:00:00";
        }
        var startTime = new Date(start).getTime();
        if (model.endIndex == 0) {
          end += " 12:00:00";
        } else {
          end += " 24:00:00";
        }
        var endTime = new Date(end).getTime();
        var result = endTime - startTime;

        return ((result / (1000 * 60 * 60 * 24)).toFixed(1) * 10) / 10;
      } else {
        start = start.replace(/-/g, "/");
        end = end.replace(/-/g, "/");
        var startTime = new Date(start).getTime();
        var endTime = new Date(end).getTime();
        var result = endTime - startTime;
        if (type == "date") {
          //天
          return ((result / (1000 * 60 * 60 * 24)).toFixed(1) * 10) / 10 + 1;
        } else {
          //时间==》小时
          return ((result / (1000 * 60 * 60)).toFixed(1) * 10) / 10;
        }
      }
    },
    //提交
    checkSub() {
      var uploadInfo = [];
      this.formInfo.formList.forEach((a) => {
        //上传组件
        if (a.set.control == "upload") {
          uploadInfo.push(a.set);
        }
      });

      if (uploadInfo.length > 0) {
        //有需要上传的
        this.uploadFile(uploadInfo, 0);
        return;
      }
      this.subForm();
    },
    uploadFile(list, index) {
      var model = list[index];

      console.log(`index:${index}`);
      var setId = model.setId;
      console.log(`setId:${setId}`);
      this.$refs[`${setId}`][0].upload().then((data) => {
        model.uploadFiles = data;
        if (index < list.length - 1) {
          index++;
          this.uploadFile(list, index);
        } else {
          this.subForm();
        }
      });
    },
    subForm() {
      console.log(`form:${JSON.stringify(this.formInfo)}`);

      var formInfo = JSON.parse(JSON.stringify(this.formInfo));
      if (!this.formInfo.serId || this.formInfo.serId == 0) {
        formInfo.formId = this.formInfo.id;
      }
      try {
        formInfo.formList.forEach((a) => {
          //先处理value转换成string
          if (a.set.control == "user_baseinfo") {
            a.set.value = this.user;
          }
          if (a.set.control == "upload") {
            if (a.set.uploadFiles) {
              a.set.value = a.set.uploadFiles.files.map((a) => {
                return a.o.fullPath;
              });
              a.set.uploadId = a.set.uploadFiles.id;
            }
          }

          if (a.set.control == "checkbox") {
            if (a.set.value != null && a.set.value != "") {
              a.set.value = a.set.value.join("，");
            }
          }
          //判断是否必填，是否有值
          if (
            a.set.required &&
            (a.set.value == null || a.set.value.length == 0)
          ) {
            throw Error(`请填写"${a.set.title}"的值`);
          }

          if (a.set.value != null) {
            a.set.value = JSON.stringify(a.set.value);
          }
        });
      } catch (e) {
        this.$Message.error(e.message);
        return;
      }

      formInfo.sendType = this.type;
      formInfo.flows = this.flows;
      console.log(`form2:${JSON.stringify(formInfo)}`);
      this.$axios({
        baseURL: this.config.OA,
        url: `form/info/data/formAndFlow`,
        method: "PUT",
        data: formInfo,
      }).then((res) => {
        if (res.code == 200) {
          var info = res.data;
          info.formList.forEach((a) => {
            if (a.set.value && a.set.value.length > 0) {
              a.set.value = JSON.parse(a.set.value);
            }
          });
          this.formInfo = res.data;
          this.page = 1;
          this.showSend = false;
          this.getData();
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    sendAction() {
      this.$axios({
        baseURL: this.config.OA,
        url: `form/info/id/${this.formId}`,
        method: "GET",
      }).then((res) => {
        if (res.code == 200) {
          var data = res.data;

          var has_school_week = false;
          var school_week_index = 0;
          data.formList.forEach((a, index) => {
            if (a.set.control == "school_week") {
              has_school_week = true;
              school_week_index = index;
            }
            if (a.set.control == "upload") {
              a.set.uploadId = "";
              a.set.uploadFiles = {
                id: "",
                files: [],
              };
            }
          });
          this.formInfo = data;
          this.formInfo.formId = this.formId;
          if (has_school_week) {
            this.getSchoolWeek(1, school_week_index);
          }
          this.initFlow();
          this.showSend = true;
        }
      });
    },
    getFormInfo() {
      this.$axios({
        baseURL: this.config.OA,
        url: `form/info/id/${this.formId}`,
        method: "GET",
      }).then((res) => {
        if (res.code == 200) {
          var data = res.data;

          var has_school_week = false;
          var school_week_index = 0;
          data.formList.forEach((a, index) => {
            if (a.set.control == "school_week") {
              has_school_week = true;
              school_week_index = index;
            }
            if (a.set.control == "upload") {
              a.set.uploadId = "";
              a.set.uploadFiles = {
                id: "",
                files: [],
              };
            }
          });
          this.formInfo = data;

          if (has_school_week) {
            this.getSchoolWeek(1, school_week_index);
          }
          this.getSet();
        }
      });
    },

    initFlow() {
      var formInfo = JSON.parse(JSON.stringify(this.formInfo));
      console.log("获取流程");
      formInfo.formList.forEach((a) => {
        //先处理value转换成string
        if (a.set.control == "user_baseinfo") {
          a.set.value = this.user;
        }
        if (a.set.control == "upload") {
          if (a.set.uploadFiles) {
            a.set.value = a.set.uploadFiles.files.map((a) => {
              return a.o.fullPath;
            });
            a.set.uploadId = a.set.uploadFiles.id;
          }
        }
        if (a.set.control == "checkbox") {
          if (a.set.value != null && a.set.value != "") {
            a.set.value = a.set.value.join("，");
          }
        }
        if (a.set.value != null) {
          a.set.value = JSON.stringify(a.set.value);
        }
      });

      formInfo.sendType = "";
      this.$axios({
        baseURL: this.config.OA,
        url: `form/info/data/flow`,
        method: "PUT",
        data: formInfo,
      }).then((res) => {
        if (res.code == 200) {
          var flows = res.data;
          this.flows = flows;
        } else {
        }
      });
    },
    getSchoolWeek(type, index) {
      this.$axios({
        baseURL: this.config.basic,
        url: `Basic/school/week`,
        method: "GET",
      }).then((res) => {
        if (res.code == 200) {
          this.weekList = res.data.list;
          this.weekList.forEach((a) => {
            a.title = `第${a.weekIndex}周(${a.start}-${a.end})`;
          });
          if (type == 1) {
            var formInfo = Object.assign({}, this.formInfo);
            var data = formInfo.formList[index];
            res.data.nowInfo.title = `第${res.data.nowInfo.weekIndex}周(${res.data.nowInfo.start}-${res.data.nowInfo.end})`;
            data.set.value = res.data.nowInfo;
            data.set.start = res.data.nowInfo.start;
            data.set.end = res.data.nowInfo.end;

            this.formInfo = formInfo;
          }
        } else {
          uni.showModal({
            title: "错误提示",
            content: res.msg,
            showCancel: false,
            confirmText: "知道了",
          });
        }
      });
    },
    editForm(index) {
      var list = JSON.parse(JSON.stringify(this.list));
      var model = list[index];
      var data = Object.assign({}, model);

      var has_school_week = false;
      var school_week_index = 0;
      var uploadIds = [];
      data.formList.forEach((a, index) => {
        if (a.set.control == "school_week") {
          has_school_week = true;
          school_week_index = index;
        }
        //是否有文件上传
        if (a.set.control == "upload") {
          if (a.set.uploadId && a.set.uploadId.length > 0) {
            uploadIds.push({
              setId: a.set.setId,
              uploadId: a.set.uploadId,
            });
          }
          a.set.uploadFiles = {
            id: "",
            files: [],
          };
        }
        var value = a.set.value;
        if (value) {
          var info = JSON.parse(value);
          a.set.value = info;
        }
      });

      if (uploadIds.length > 0) {
        this.getUploadInfo(uploadIds);
      }

      this.formInfo = Object.assign({}, data);
      if (has_school_week) {
        this.getSchoolWeek(2, school_week_index);
      }

      this.formInfo = Object.assign({}, model);
      this.showSend = true;
    },
    changeFile(files, setId) {
      var formInfo = Object.assign({}, this.formInfo);
      var formList = formInfo.formList.filter((a) => {
        return a.set.setId == setId;
      });
      if (formList && formList.length > 0) {
        var model = formList[0];
        model.set.uploadFiles = files;

        var index = formInfo.formList.indexOf(model);
        formInfo.formList.splice(index, 1, model);
      }
      this.formInfo = formInfo;
      console.log(`form:${JSON.stringify(this.formInfo)}`);
    },
    getUploadInfo(uploadIds) {
      var self = this;
      uploadIds.forEach((a) => {
        self
          .$axios({
            baseURL: this.config.OA,
            url: `upload/${a.uploadId}`,
            method: "GET",
          })
          .then((res) => {
            if (res.code == 200) {
              var setId = a.setId;
              var formInfo = Object.assign({}, self.formInfo);
              var formList = formInfo.formList.filter((a) => {
                return a.set.setId == setId;
              });
              if (formList && formList.length > 0) {
                var model = formList[0];
                model.set.uploadFiles = res.data;
                var index = formInfo.formList.indexOf(model);
                formInfo.formList.splice(index, 1, model);
              }

              this.formInfo = formInfo;
            }
          });
      });
    },
    deleteForm(index) {
      var model = this.list[index];
      var self = this;
      this.$Modal.confirm({
        title: "删除提示",
        content: `确认删除此条申请么？删除后不可以恢复`,
        onOk: () => {
          this.$axios({
            baseURL: this.config.OA,
            url: `form/info/data/${model.serId}`,
            method: "DELETE",
          }).then((res) => {
            if (res.code == 200) {
              self.getData();
            } else {
              this.$Message.error(res.msg);
            }
          });
        },
      });
    },
    getSet() {
      this.$axios
        .request({
          baseURL: this.config.OA,
          url: `form/info/set/${this.formId}`,
          method: "GET",
        })
        .then((res) => {
          if (res.code == 200) {
            this.formSet = res.data;
            this.setTabColumn();
            this.getData();
          }
        });
    },
    getData() {
      this.$axios({
        baseURL: this.config.OA,
        url: `form/info/data/type/${this.formId}`,
        method: "POST",
        data: {
          type: 0,
          action: 0,
          plat: "pc",
          page: this.currentPage,
          pageSize: this.currentPageSize,
        },
      }).then((res) => {
        if (res.code == 200) {
          this.total = res.data.total;
          this.list = res.data.list;
        }
      });
    },
    setTabColumn() {
      var column = [];

      if (this.formSet.titleSet && this.formSet.titleSet.formItems) {
        //标题设置
        this.formInfo.formList.forEach((a) => {
          var info = this.formSet.titleSet.formItems.filter((x) => {
            return a.set.setId && a.set.setId == x;
          });

          if (info != null && info.length > 0) {
            if (a.set.control == "datepicker" && a.set.type == "range") {
              column.push({
                title: a.set.title,
                key: a.set.setId,
                slot: "datepicker_start",
              });
              column.push({
                title: a.set.title2,
                key: a.set.setId,
                slot: "datepicker_end",
              });
              if (a.set.isDuration) {
                column.push({
                  title: a.set.timeLongTitle,
                  key: a.set.setId,
                  slot: "datepicker_timelong",
                });
              }
            } else {
              if (column.length == 0) {
                column.push({
                  title: a.set.title,
                  key: a.set.setId,
                  slot: "content",
                  fixed: "left",
                  tooltip: true,
                  maxWidth: 500,
                });
              } else {
                column.push({
                  title: a.set.title,
                  key: a.set.setId,
                  slot: "content",
                  tooltip: true,
                  maxWidth: 500,
                });
              }
            }
          }
        });
      }

      column.push({
        title: "添加时间",
        key: "createTime",
      });
      if (this.formInfo.type == 1) {
        column.push({
          title: "状态",
          key: "status",
          slot: "status",
          fixed: "right",
          width: 150,
        });
      }
      column.push({
        title: "操作",
        key: "action",
        slot: "action",
        fixed: "right",
        width: 200,
      });

      this.tableColumns = column;
    },

    getDatePickerRang(info, column, type) {
      var list = info.formList.filter((a) => {
        return a.set.setId == column.key;
      });

      var model = null;
      if (list && list.length > 0) {
        model = list[0];
      }
      if (model == null) return "";

      if (model.set.control == "datepicker" && model.set.type == "range") {
        var value = JSON.parse(model.set.value);
        if (type == 1) {
          var title = model.set.start;
          if (model.set.isTil) {
            title += ` ${this.dateDay[model.set.startIndex].title}`;
          }
          return title;
        }
        if (type == 2) {
          var title = model.set.end;
          if (model.set.isTil) {
            title += ` ${this.dateDay[model.set.endIndex].title}`;
          }
          return title;
        }
        if (type == 3) {
          var unit = "（小时）";
          if (model.set.unit == "date") {
            unit = "（天）";
          }
          return `${value}${unit}`;
        }

        return "";
      }
    },

    getInfo(info, column, index) {
      var list = info.formList.filter((a) => {
        return a.set.setId == column.key;
      });

      var model = null;
      if (list && list.length > 0) {
        model = list[0];
      }
      if (model == null) return "";

      var title2 = model.set.value;
      if (model.set.control == "hq_wz"  || model.set.control == "wz_sq") {
        var value = JSON.parse(model.set.value);
        var title = "";

        value.forEach((a) => {
          title += `物品：${a.title},申请数量：${a.count}\n`;
        });
        title2 = title;
      } else if (
        model.set.control == "class_stu" ||
        model.set.control == "xb_grade" ||
        model.set.control == "xb_sub"
      ) {
        var value = JSON.parse(model.set.value);
        title2 = value.title;
      } else if (model.set.control == "xb_teacher") {
        var value = JSON.parse(model.set.value);
        title2 = value.title;
      } else if (model.set.control == "xb_place") {
        var value = JSON.parse(model.set.value);
        title2 = value.title;
      } else if (model.set.control == "user_baseinfo") {
        var value = JSON.parse(model.set.value);
        title2 = value.name;
        if (value.type == "student") {
          title2 += `/${value.className}`;
        }
      } else if (model.set.control == "school_week") {
        var value = JSON.parse(model.set.value);
        title2 = value.title;
      } else if (
        model.set.control == "datepicker" &&
        model.set.type == "range"
      ) {
        var value = JSON.parse(model.set.value);
        title2 = `${model.set.start}-${model.set.end}`;
        var unit = "（小时）";
        if (model.set.unit == "date") {
          unit = "（天）";
        }
        if (model.set.isDuration) {
          title2 += `，${model.set.timeLongTitle}：${value}${unit}`;
        }
      } else {
        title2 = JSON.parse(model.set.value);
      }

      return title2;
    },

    getStatusTitle(status, action) {
      var title = "";
      if (status == 0) {
        switch (action) {
          case 1:
            title = "待审核";
            break;
          case 4:
            title = "待办理";
            break;
          default:
            title = "已完成";
            break;
        }
      } else {
        switch (action) {
          case 2:
            title = "已通过";
            break;
          case 3:
            title = "已拒绝";
            break;
          case 6:
            title = "已拒绝";
            break;
          default:
            title = "已完成";
            break;
        }
      }
      return title;
    },
    getStatuColor(status, action) {
      var color = "";
      if (status == 0) {
        switch (action) {
          case 1:
            color = "warning";
            break;
          case 4:
            color = "warning";
            break;
          default:
            color = "success";
            break;
        }
      } else {
        switch (action) {
          case 2:
            color = "success";
            break;
          case 3:
            color = "error";
            break;
          case 6:
            color = "error";
            break;
          default:
            color = "success";
            break;
        }
      }
      return color;
    },

    ////
    canEdit(model) {
      return false;
      // if (this.dataId == 0) return false;
      // if (!this.formInfo.serId || this.formInfo.serI ==0 ) return false;

      // if (this.type && this.type == 'resend') return false;
      // //编辑==》为设置可以编辑内容 == 》 不可修改
      // if (this.editSet == null || this.editSet.length == 0) return true;

      // var info = this.editSet.filter(a => {
      // 	return a == model.setId
      // });
      // if (info != null && info.length > 0) {
      // 	return false;
      // }
      return true;
    },
  },
  created() {
    this.getFormInfo();
    this.getUsers();
  },
};
